import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getPosDataBySessionId } from '../../store/Sales/Pos/PosSlice';

type Props = {
  SessionId: string;
};
const useGetPosDataBySessionId = ({ SessionId }: Props) => {
  const dispatch = useAppDispatch();

  const { i18n } = useTranslation();

  useEffect(() => {
    dispatch(getPosDataBySessionId(SessionId));
  }, [SessionId, dispatch]);

  const { PosDataBySession, loading2: loading, error2: error } = useAppSelector(a => a.Pos);

  const ItemsList = PosDataBySession?.itemsList?.map(m => ({
    itemId: m.itemId,
    barcode: m.barcode,
    categoryId: m.categoryId,
    categoryName: i18n.language === 'en' ? m.categoryName : m.categoryName2,
    categoryIcon: m.categoryIcon,
    enabledFlag: m.enabledFlag,
    isPrimaryUOM: m.isPrimaryUOM,
    title: i18n.language === 'en' ? m.name : m.name2,
    unitOfMeasureName: i18n.language === 'en' ? m.unitOfMeasureName : m.unitOfMeasureName2,
    unitOfMeasureId: m.unitOfMeasure,
    price: m.unitPrice,
    image:
      'https://media.licdn.com/dms/image/D4D12AQEFpeQHJkC50g/article-cover_image-shrink_720_1280/0/1667896412196?e=2147483647&v=beta&t=EEBUH-kM2vS3WF2KlDYBY6U6EaNAdj_WSwKLOR7UbMM',
    options: m.attributeList
  }));

  const CategoriesList = [
    ...new Map(
      ItemsList?.map(item => [
        item.categoryId,
        { id: item.categoryId, name: item.categoryName, icon: item.categoryIcon }
      ])
    ).values()
  ]; // ة (Set) التي تزيل القيم المكررة تلقائيًا.

  return { PosDataBySession, CategoriesList, ItemsList, loading, error };
};

export default useGetPosDataBySessionId;
